import { MouseEventHandler, forwardRef, useCallback } from "react";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import Button from "@/shared/ui/button/Button";

export interface SoundButtonProps extends React.ComponentProps<typeof Button> {
  sound?: Soundtrack;
}

const SoundButton = forwardRef<HTMLButtonElement, SoundButtonProps>(
  ({ sound = Soundtrack.DefaultClick, onClick, ...props }, forwardedRef) => {
    const { play } = useInterfaceSoundCore(sound);

    const onClickWrapper: MouseEventHandler<HTMLButtonElement> = useCallback(
      (event) => {
        if (onClick) {
          onClick(event);
          play();
        }
      },
      [play, onClick],
    );

    return <Button ref={forwardedRef} onClick={onClickWrapper} {...props} />;
  },
);

SoundButton.displayName = "SoundButton";

export default SoundButton;
